import { MonitoringSeriesTypeEnum } from '../../Monitor/Shared/enums/monitoring-series-type.enum';

/**
 * Icon shown against a source, per the Source Icons design. Shared by the agent card and the agent
 * sidebar so a source looks the same wherever it is listed.
 *
 * @TODO: confirm the Theme and Social Topic glyphs against the design - the sheet shows them but
 * does not name them, so these are the closest matches in the kit.
 */
export const sourceTypeIcons: Partial<Record<MonitoringSeriesTypeEnum, string>> = {
    [MonitoringSeriesTypeEnum.topic]: 'fa-solid fa-magnifying-glass',
    [MonitoringSeriesTypeEnum.folder]: 'fa-solid fa-folder',
    [MonitoringSeriesTypeEnum.tag]: 'fa-solid fa-tag',
    [MonitoringSeriesTypeEnum.tagGroup]: 'fa-solid fa-tags',
    [MonitoringSeriesTypeEnum.sourceGroup]: 'fa-kit fa-agpr-source-group',
    [MonitoringSeriesTypeEnum.subscription]: 'fa-solid fa-envelope-open-text',
    [MonitoringSeriesTypeEnum.theme]: 'fa-kit fa-agpr-social-theme',
    [MonitoringSeriesTypeEnum.socialTopic]: 'fa-kit fa-agpr-social-topic',
    [MonitoringSeriesTypeEnum.aiAgent]: 'fa-kit-duotone fa-agpr-ai-generic'
};

/** Fallback for a source whose type has no icon of its own */
export const defaultSourceTypeIcon: string = sourceTypeIcons[MonitoringSeriesTypeEnum.topic];

/** Name of each source type, for the tooltip the spec puts on the icon */
export const sourceTypeLabels: Partial<Record<MonitoringSeriesTypeEnum, string>> = {
    [MonitoringSeriesTypeEnum.folder]: 'Monitoring.source.type.folder',
    [MonitoringSeriesTypeEnum.topic]: 'Monitoring.source.type.topic',
    [MonitoringSeriesTypeEnum.tag]: 'Monitoring.source.type.tag',
    [MonitoringSeriesTypeEnum.tagGroup]: 'Monitoring.source.type.tagGroup',
    [MonitoringSeriesTypeEnum.sourceGroup]: 'Monitoring.source.type.sourceGroup',
    [MonitoringSeriesTypeEnum.subscription]: 'Monitoring.source.type.subscription',
    [MonitoringSeriesTypeEnum.theme]: 'Monitoring.source.type.theme',
    [MonitoringSeriesTypeEnum.socialTopic]: 'Monitoring.source.type.socialTopic',
    [MonitoringSeriesTypeEnum.aiAgent]: 'Monitoring.source.type.aiAgent'
};
